import { WorklistSurface, WorklistSurfaceType } from '../types';

export const getSurfaceLabel = (tab: WorklistSurfaceType): string => {
  switch (tab) {
    case WorklistSurface.MY_QUEUE:
      return 'My Queue';
    case WorklistSurface.QC:
      return 'QC';
    case WorklistSurface.PENDING:
      return 'Pending';
    case WorklistSurface.IN_PROGRESS:
      return 'In Progress';
    case WorklistSurface.RECENTLY_READ:
      return 'Recently Read';
    case WorklistSurface.ARCHIVE:
      return 'Archive';
    default:
      return 'Pending';
  }
};

/**
 * Compares worklist names with case-insensitive matching
 */
const compareWorklistNames = (name1: string, name2: string): boolean => {
  return name1.toLowerCase().trim() === name2.toLowerCase().trim();
};

export const isProvidedCannedWorklist = ({
  currentSurface,
  comparatorSurface,
  customWorklistName,
}: {
  currentSurface: WorklistSurfaceType;
  comparatorSurface: string | string[];
  customWorklistName?: string | null;
}): boolean => {
  if (currentSurface == null) {
    return false;
  }

  const comparatorSurfaces = Array.isArray(comparatorSurface)
    ? comparatorSurface
    : [comparatorSurface];

  if (comparatorSurfaces.length === 0) {
    return false;
  }

  if (currentSurface !== WorklistSurface.CUSTOM_WORKLIST) {
    return comparatorSurfaces.includes(currentSurface);
  }

  if (customWorklistName == null || customWorklistName.trim() === '') {
    return false;
  }

  return comparatorSurfaces.some((comparator) => {
    const labelToCompare = getSurfaceLabel(comparator as WorklistSurfaceType);

    if (labelToCompare == null) {
      return false;
    }

    return compareWorklistNames(customWorklistName, labelToCompare);
  });
};

// This works very similarly to above, but takes in an array of names instead
export const isAnyProvidedCannedWorklist = ({
  currentSurface,
  comparatorSurface,
  customWorklistNames = [],
}: {
  currentSurface: WorklistSurfaceType;
  comparatorSurface: WorklistSurfaceType;
  customWorklistNames?: (string | null)[];
}): boolean => {
  if (currentSurface == null) {
    return false;
  }

  if (currentSurface !== WorklistSurface.CUSTOM_WORKLIST) {
    return currentSurface === comparatorSurface;
  }

  if (customWorklistNames.length === 0) {
    return false;
  }

  const labelToCompare = getSurfaceLabel(comparatorSurface as WorklistSurfaceType);

  if (labelToCompare == null) {
    return false;
  }

  return customWorklistNames.some(
    (customWorklistName) =>
      customWorklistName && compareWorklistNames(customWorklistName, labelToCompare)
  );
};
